import "./header.css";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import React, { useState, useEffect } from "react";

function Navigation() {
    return (
        <nav className="navigation">
            <ul>
                <li>
                    <NavLink to="/media" className={({ isActive }) => isActive ? "selectedlink" : "notselectedlink"}>Media</NavLink>
                </li>
                <li>
                    <a rel="noreferrer" target="_blank" href="http://eepurl.com/jikH5k">Subscribe</a>
                </li>
                <li>
                    <NavLink to="/gospel" className={({ isActive }) => isActive ? "selectedlink" : "notselectedlink"}>The Gospel in 30 Days</NavLink>
                </li>
                <li>
                    <NavLink to="/submarine" className={({ isActive }) => isActive ? "selectedlink" : "notselectedlink"}>Sub-Marine</NavLink>
                </li>
                <li>
                    <NavLink to="/about" className={({ isActive }) => isActive ? "selectedlink" : "notselectedlink"}>About</NavLink>
                </li>

                {/* <li>
                    <a rel="noreferrer" target="_blank" href="https://beholdchristdaily.com/daily">Behold Christ</a>
                </li> */}
                {/* <li>
                    <NavLink to="/photos" className={({ isActive }) => isActive ? "selectedlink" : "notselectedlink"}>Photos</NavLink>
                </li> */}
            </ul>
        </nav>
    );
}

function Header() {
    const [isTablet, setIsTablet] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const checkIfTablet = () => {
            const width = window.innerWidth;
            setIsTablet(width <= 1000);
        };

        checkIfTablet(); // run on mount
        window.addEventListener("resize", checkIfTablet);
        return () => window.removeEventListener("resize", checkIfTablet);
    }, []);

    const isHome = location.pathname === "/" || location.pathname === "/about";

    return (
        <section className="header">
            <h1>Josiah Swanson</h1>
            {(isTablet && !isHome) ? (
                <button className="go-back-button" onClick={() => navigate("/")}>
                    Go Home
                </button>
            ) : (
                <Navigation />
            )}
        </section>
    );
}

export default Header;
